var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6026 3C17.3601 3 17.1175 3.09281 16.9328 3.27755L15.0381 5.17229L13.6984 6.51192L3 17.2105V21H6.78942L20.7222 7.06702C21.0926 6.6966 21.0926 6.09686 20.7222 5.72739L18.2724 3.27755C18.0877 3.09281 17.8451 3 17.6026 3ZM17.6026 5.28701L18.7128 6.3972L17.4879 7.62212L16.3777 6.51192L17.6026 5.28701ZM15.0381 7.85156L16.1482 8.96176L6.00489 19.1053H4.89471V17.9951L15.0381 7.85156Z",
    fill: "currentColor"
  })));
}
export default SvgPencilreact;